// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".buy-now[data-v-30a6e29b]{width:100%;padding:1rem;background:#ededed}@media screen and (min-width:576px) and (max-width:767px){.product-main-wrapper .quick-v-tocart[data-v-30a6e29b]{max-width:100%}}", ""]);
// Exports
module.exports = exports;
